
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-budget",
      function () {
        return require("private-next-pages/request-budget/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-budget"])
      });
    }
  